module.exports = __webpack_public_path__ + "static/media/summer-bum-bg.79b0668b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider-banners/summer-bum/summer-bum-bg.png
// module id = 910
// module chunks = 7